<template>
  <StoreCartTrigger
    v-if="isStorePage && showCart"
    :trigger-button-class="navigationActionButtonClass"
    :trigger-icon-class="navigationActionIconClass"
    :trigger-badge-class="navigationActionBadgeClass"
  />

  <DraftOrdersTrigger
    v-else-if="showCart"
    :trigger-button-class="navigationActionButtonClass"
    :trigger-icon-class="navigationActionIconClass"
    :trigger-badge-class="navigationActionBadgeClass"
  />

  <NotificationsDrawer
    v-if="notifications.showNotifications.value"
    :items="notifications.notificationsStore.items"
    :unread-count="notifications.notificationsStore.unreadCount"
    :is-loaded="notifications.notificationsStore.isLoaded"
    :model-value="notifications.notificationsStore.isPanelOpen"
    :is-connecting="notifications.notificationsStore.isConnecting"
    :is-fetching-more="notifications.notificationsStore.isFetchingMore"
    :is-deleting="notifications.isDeletingNotifications.value"
    :delete-success-key="notifications.notificationDeleteSuccessKey.value"
    :has-next-page="notifications.notificationsStore.hasNextPage"
    :last-received-at="notifications.notificationsStore.lastReceivedAt"
    :error="notifications.notificationsStore.error"
    :trigger-button-class="navigationActionButtonClass"
    :trigger-icon-class="navigationActionIconClass"
    :trigger-badge-class="navigationActionBadgeClass"
    @update:model-value="notifications.notificationsStore.setPanelOpen"
    @mark-all-read="notifications.handleMarkAllNotificationsAsRead"
    @delete="notifications.handleDeleteNotifications"
    @notification-selected="notifications.handleNotificationSelect"
    @load-more="notifications.handleLoadMoreNotifications"
  />
</template>

<script setup lang="ts">
import DraftOrdersTrigger from '~/components/DraftOrdersTrigger.vue'
import StoreCartTrigger from '~/components/StoreCartTrigger.vue'
import NotificationsDrawer from '~/components/dashboard/drawers/NotificationsDrawer.vue'
import type { useNotificationsNav } from '~/composables/useNotificationsNav'

withDefaults(
  defineProps<{
    /** Whether the current navigation offers a cart. */
    showCart: boolean
    /** Selects the store cart on store pages and draft orders elsewhere. */
    isStorePage?: boolean
    /** Notification state and actions owned by the navigation instance. */
    notifications: ReturnType<typeof useNotificationsNav>
  }>(),
  { isStorePage: false }
)

const navigationActionButtonClass =
  'relative inline-flex size-10 items-center justify-center rounded-full text-content-level-500 transition-colors hover:bg-surface-level-100 hover:text-content-level-700 dark:text-content-level-400 dark:hover:bg-surface-canvas/5 dark:hover:text-content-inverse cursor-pointer'
const navigationActionIconClass = 'h-5 w-5'
const navigationActionBadgeClass =
  'absolute right-0 top-0 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-xs font-medium leading-none text-content-inverse shadow-sm'
</script>
